import type { CashFlowRow } from '../../financialintel/framework';

type Props = { rows?: CashFlowRow[] };

export function CashFlowIntelligencePanel({ rows = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
      {rows.map((r) => (
        <div key={r.label} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{r.label}</p>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{r.current}</p>
          <p className="text-lg font-semibold text-slate-900 dark:text-slate-100">→ {r.forecast}</p>
        </div>
      ))}
    </div>
  );
}
